import mixpanel from "mixpanel-browser";
import { userId } from "./creatine-streak-tracker/persistence/api-client";

const TOKEN = "9a6dc392e86f2ea00182898c69f9a3ac";

let initialized = false;

export function initMixpanel(): void {
  if (initialized) return;
  if (!import.meta.env.PROD) return; // match Sentry: dev/test are no-ops

  mixpanel.init(TOKEN, {
    track_pageview: false,
    persistence: "localStorage",
  });
  mixpanel.register({ app: "streak-tracker" });

  if (userId) mixpanel.identify(userId);
  initialized = true;
}

export type MixpanelEvent =
  | "APP_OPENED"
  | "APP_ONBOARDING_STARTED"
  | "APP_DAILY_CHECKIN_COMPLETED"
  | "APP_MILESTONE_ACHIEVED"
  | "APP_STREAK_BROKEN"
  | "APP_NEW_STREAK_STARTED";

export function track(
  event: MixpanelEvent,
  props?: Record<string, unknown>,
): void {
  if (!initialized) return;

  mixpanel.track(event, props);
}
